import { DEFAULT_STATS } from '../../../core/constants';

/**
 * 배송 건수 엔티티
 */
export type DeliveryCount = {
  seqNo: number | null;
  supplyId?: string;
  riderId?: string;
  deliveryDate?: string;
  finishCnt?: number;
  rejectCnt?: number;
  assingCancelCnt?: number;
  deliCancelCnt?: number;
  morTimeCnt?: number;
  afterNonCnt?: number;
  nightNonCnt?: number;
  nightCnt?: number;
  totDeliveryAtm?: number;
};

export type HomePageDeliveryCountRequest = {
  fromDate?: string;
};

export type HomePageDeliveryCountResponse = {
  suppId?: string;
  riderId?: string;
  fromDate?: string;
  deliveryDataList?: DeliveryCount[];
  success?: boolean;
  message?: string;
};

/**
 * 배송 통계 엔티티
 */
export type HomePageDeliveryStats = {
  completedCount: number;
  rejectedCount: number;
  acceptanceRate: number;
  deliveryFee: number;
  morningLunchPeakCount: number;
  afternoonNonPeakCount: number;
  eveningPeakCount: number;
  nightPeakCount: number;
};

export const DEFAULT_HOME_PAGE_DELIVERY_STATS: HomePageDeliveryStats = DEFAULT_STATS;
